<div class="paddingContainer flex-column cdk-overlay-pane">
    <div class="row row-containe-gap">
      <div class="column">
        <div class="heading mb-5">Type Of File</div>
        <div
          class="file-type"
          [attr.id]="buildControlId('file-type-value')"
        >{{ fileMetaData[0] }}</div>
      </div>
      <div class="column p-r-m">
        <div class="heading mb-5">Size</div>
        <div class="size"
        matTooltipClass="tooltip-style" 
        matTooltipPosition="below"
        [matTooltip]="fileMetaData[2]"
        [matTooltipDisabled]="fileMetaData[1] === '0 Bytes' || fileMetaData[1].endsWith('Bytes')"
        [attr.id]="buildControlId('file-size-value')"> {{ fileMetaData[1] }}</div>
      </div>
    </div>
    <div class="row">
      <div class="column">
        <div class="heading mb-5 m-t-xs">Modified On</div>
        <div class="modified-on">
          <div>{{ fileMetaData[3] + "Z" | date : "dd MMM yyyy" }}</div>
          <div class="m-t-xs">{{ fileMetaData[3] + "Z" | date : "HH:mm:ss" }}</div>
        </div>
      </div>
    </div>
</div>
